import React, { useEffect, useState } from 'react';
import './style.modules.css';
import logo from '../../assets/img/Sobr.png';
import Navbar from '../../components/navbarus';
import vector6 from '../../assets/img/Vector6.png';
import arrow from '../../assets/img/arrow.svg';
import midias from '../../assets/img/Social Media.svg';
import africangirl from '../../assets/teamsobr/africangirl.png'
import vector13 from '../../assets/teamsobr/vector13.svg'
import vector14 from '../../assets/teamsobr/vector14.svg'
import vector15 from '../../assets/teamsobr/vector15.svg'
import vector16 from '../../assets/teamsobr/vector16.svg'
import couple2 from '../../assets/teamsobr/couple2.png'
import malte from '../../assets/img/maltefoto.jpg'
import ricardo from '../../assets/img/ricardofoto.jpg'
import koch from '../../assets/img/kochfoto.jpg'
import digao from '../../assets/img/digaofoto.jpg'
import felipe from '../../assets/img/felipefoto.jpg'
import erico from '../../assets/img/erikofoto.jpg'
import { useNavigate } from 'react-router-dom';
function TeamSobr() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        // Limpar o listener quando o componente desmontar
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);  
    // Função para rolar até o menu principal
    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo'); // Seleciona o primeiro elemento com a classe 'logo'
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return(
<>
        < Navbar/>    
    <div className="logo">
        <img src={logo} height="36" width="78" alt="logo" title="logo"/>
    </div>
        <img className="shade" src={vector13} alt="shade" title="shade"/>
        <img className="couple2" src={couple2} alt="couple" title="couple" height="400px" width="350px"/>
    <div className='couple-border'></div>
    <div className="content6">
    <h1>Welcome to Sobr, where the journey to happiness is vibrant and encouraging</h1>
    <p> We are much more than a dating app - we are a community dedicated to redefining the concept of happiness by putting sobriety at the center of everything we do.
    </p> 
    </div>
    <div className="container10">
    <div className="background">
        <img src={vector14} alt="Background" />
    </div>
    <div className="overlay">
        <img src={africangirl} alt="Girl" className="girl"height="400px" width="350px" />
    </div>
    </div>
        <div className="content6">
        <p>At Sobr, we believe that true happiness is not only possible, but attainable for everyone. Our mission is to provide a welcoming and empowering space for those who choose to live a sober life, celebrating every moment of joy, every achievement and every step towards personal growth.        </p>
        <p>Our commitment to authenticity, health and genuine sober relationships is what drives us every day. Here, you'll find a vibrant community of like-minded people ready to support, inspire and empower each other on their sobriety journeys.</p>
        <p>So if you're ready to embark on a journey of self-knowledge, meaningful connection and authentic joy, you've come to the right place. Join us at Sobr and let's revolutionize happiness together.      </p>
    </div>
    <div className="content7">
        <h1>Welcome to our community. Welcome to Sobr.        </h1>
    </div>
 {/*    <div className="review-box">
        <div className="header">
            <h3>Margie V.</h3>
            <p>Montevideo</p>
        </div>
    <div className="starx">
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="time">2 months ago</span>
    </div>
    <div className="content">
        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
    </div>
    <div className="verified">
        <span>Verified by</span>
    </div>
    </div>
    <div className="review-box">
        <div className="header">
            <h3>Margie V.</h3>
            <p>Montevideo</p>
        </div>
    <div className="starx">
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="time">2 months ago</span>
    </div>
    <div className="content">
        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
    </div>
        <div className="verified">
            <span>Verified by</span>
        </div>
        </div>  
        <div className="review-box">
            <div className="header">
                <h3>Margie V.</h3>
                <p>Montevideo</p>
        </div>
        <div className="starx">
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="time">2 months ago</span>
        </div> 
            <div className="content">
                <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
            </div>
            <div className="verified">
                <span>Verified by</span>
            </div> 
            </div>*/}
    <div className="team-container">
        
        <div className="team-cardx">
        <div className="profile-image-container">
            <img src= {digao} alt="Rodrigo" className="profile-image" />
        </div>
        <div className="team-info">
            <h2 className="team-name">Rodrigo Oliveira</h2>
            <h3 className="team-title">Co-Founder and Commercial Director</h3>
            <p className="team-description">
            Has worked at companies such as Panasonic Brazil, Stanley’s Care, among others...
            </p>
        </div>
        </div>
        <div className="team-cardx">
        <div className="profile-image-container">
            <img src={felipe} alt="Felipe" className="profile-image" />
        </div>
            <div className="team-info">
            <h2 className="team-name">Felipe Alarcon</h2>
            <h3 className="team-title">Co-Founder and CEO</h3>
            <p className="team-description">
            Was the operations manager at BITNATION, winner of UNESCO's Grand Prix, and product manager at CryptoMarket.
            </p>
        </div>
        </div>
        <div className="team-cardx">
        <div className="profile-image-container">
            <img src={koch} alt="Ricardo Aquino" className="profile-image" />
        </div>
        <div className="team-info">
            <h2 className="team-name">Marcus Koch</h2>
            <h3 className="team-title">Co-Founder and CTO</h3>
            <p className="team-description">
            Collaborated in the creation of the DocPlanner group’s app.
            </p>
        </div>
        </div>
        <div className="team-cardx">
        <div className="profile-image-container">
            <img src= {erico} alt="Érico Ramos" className="profile-image" />
        </div>
        <div className="team-info">
            <h2 className="team-name">Érico Ramos</h2>
            <h3 className="team-title">Minority Shareholder</h3>
            <p className="team-description">
            Worked as a consultant at Accenture, Google, and Nokia.
            </p>
        </div>
        </div>
        <div className="team-cardx">
        <div className="profile-image-container">
            <img src={malte} alt="Malte Niebelschuetz" className="profile-image" />
        </div>
            <div className="team-info">
            <h2 className="team-name">Malte Niebelschuetz</h2>
            <h3 className="team-title">Commercial Director - USA</h3>
            <p className="team-description">
            Worked as a project manager at Deutsche Telekom and now has business in San Diego.
            </p>
        </div>
        </div>
        <div className="team-cardx">
        <div className="profile-image-container">
            <img src={ricardo} alt="Ricardo Aquino" className="profile-image" />
        </div>
        <div className="team-info">
            <h2 className="team-name">Ricardo Aquino</h2>
            <h3 className="team-title">CMO</h3>
            <p className="team-description">
            Contributed to brands such as Petrobras, Ponto Frio, Grupo Pão de Açúcar, among others.
            </p>
        </div>
        </div>
    
        </div>





            <div className="shade2" style={{ backgroundImage: `url(${vector6})` }}>
            </div>
            <div className="midias">           
                <img className="midias" src={midias} height="24" width="260" alt="mídias" title="mídias"/>
            </div>
            <footer>
                <div className="footer-content">
                    <p>Terms of Service | Privacy Policy</p> 
                </div>
                <div className="footer-copyright">
                &copy; 2024 Sobr Inc. All rights reserved    
                </div>
                {/* Ícone da seta para rolar até o menu principal */}
                <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                    <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top"/>
                </div>
            </footer>

</>
)
}
export default TeamSobr;

